import { styled } from "@mui/system";
import { FaCheck } from "react-icons/fa";

import { colors, others } from "../../../styles/colors";

export const OuterBodyGrid = () => ({
    backgroundColor: colors.backgroundColor[7],
    opacity: 1,
});

export const LeftGrid = () => ({
    background: others.otherColors[33],
    boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
    opacity: 1,
    padding: "0.5rem 1rem 1rem 1rem",
    borderRadius: "0.8rem",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const rightGridStyle = () => ({
    alignItem: "center",
    padding: "12rem 5rem 12rem 5rem",
    height: "100%"
});

export const BoxStyle = () => ({
    margin: "0.5rem",
    display: "flex",
    marginBottom: '10px',
});

export const FaCheckCircleIcon = styled(FaCheck)(() => ({
    color: colors.brand.secondary,
}));

export const CheckBoxStyle = () => ({
    display: "flex",
    alignItems: "center",
    minWidth: "7.1rem",
});

export const DataTextField = () => ({
    "& .MuiInput-input": {
        WebkitBoxShadow: `0 0 0 62.5rem ${colors.backgroundColor[9]} inset`,
    },
    "& .MuiInputLabel-root": {
        display: "flex",
    },
});